/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Settings_LanguageInputs */

const he_extension_popup_settings_language = /** @type {(inputs: Extension_Popup_Settings_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שפה:`)
};

const en_extension_popup_settings_language = /** @type {(inputs: Extension_Popup_Settings_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language:`)
};

/**
* | output |
* | --- |
* | "Language:" |
*
* @param {Extension_Popup_Settings_LanguageInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const extension_popup_settings_language = /** @type {((inputs?: Extension_Popup_Settings_LanguageInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Settings_LanguageInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_settings_language(inputs)
	return en_extension_popup_settings_language(inputs)
});